import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllAllergens, GetDietTypes } from '../../../../../reduxToolkit/FoodieDishes/DishesApi';
import { useTranslation } from 'react-i18next';
import { Allergens } from '../../../../../enums/FoodieIcons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const AllergensApp = (dietType, allergens, setSelectedDietTypes, setSelectedAllergens, selectedDietTypes, handleDietTypeDelete) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { dietTypesAll } = useSelector((state) => state.DishSlice);
    const { allAlergens } = useSelector((state) => state.DishSlice);
    // Initialize selected diet types if provided
    useEffect(() => {
        if (dietType?.length) {
            setSelectedDietTypes(dietType);
        }
    }, [dietType]);
    // Initialize selected allergens if provided
    useEffect(() => {
        if (allergens?.length && allAlergens?.length) {
            const selected = allAlergens
                .filter((item) => allergens.includes(item.id))
                .map((item) => ({
                    id: item.id,
                    label: Allergens[item.id].name,
                }));
            setSelectedAllergens(selected);
        }
    }, [allergens, allAlergens]);
    // Fetch all diet types and allergens on mount
    useEffect(() => {
        dispatch(GetDietTypes());
        dispatch(GetAllAllergens());
    }, []);
    // Build allergen options for select components
    const allergenOptions =
        allAlergens?.map((item) => ({
            id: item.id,
            label: item.name,
        })) || [];

        

    /**
     * Toggles a diet type in the selection list.
     *
     * @param {number} id - ID of the diet type.
     * @param {string} name - Name of the diet type.
     */
    const handleDietTypeChange = (id, name) => {
        setSelectedDietTypes((prevSelected) => {
            const dietTypesArray = Array.isArray(prevSelected) ? prevSelected : [];
            const exists = dietTypesArray.some((item) => (typeof item === 'object' ? item.id : item) === id);

            if (exists) {
                 handleDietTypeDelete?.({ id });
                return dietTypesArray.filter((item) => (typeof item === 'object' ? item.id : item) !== id);
            } else {
                return [...dietTypesArray, { id, name }];
            }
        });
    };

    const transformedAllergenOptions = allergenOptions.map((item) => ({
        id: item.id,
        label: t(Allergens[item.id].name),
    }));
    return {
        dietTypesAll,
        handleDietTypeChange,
        allergenOptions: transformedAllergenOptions,
    };
};

export default AllergensApp;
